import { Box } from '@origin-digital/layout';
import { interaction } from '@origin-digital/reporting-client';
import { AlertBox, Button, LinkChevron, Text, TextField } from '@origin-digital/style-guide';
import * as React from 'react';
import { ChangeEvent, FocusEvent, FormEvent, useState } from 'react';
import { AuthCard } from 'ts/components/Card';
import { Heading } from 'ts/components/Heading';
import { InfoText } from 'ts/components/InfoText';
import { BackButton } from '../../sub-components/back-button/BackButton';
import { AccountNumberInfoModalView } from './AccountNumberInfoModalView';
import { Content } from './Interfaces';
import { Page } from '../../../../components/Page';

interface AccountNumberProps {
  onAccountNumberChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: FormEvent<HTMLButtonElement>) => void;
  onAccountNumberBlur: (event: FocusEvent<HTMLInputElement>) => void;
  accountNumberError: string;
  history: any;
  spinner: boolean;
  alertBoxError: string;
  content: Content;
  accountNumberTransform: (value: string, prevValue: string) => string;
}

const AccountNumberView: React.FC<AccountNumberProps> = ({
  onSubmit,
  onAccountNumberChange,
  onAccountNumberBlur,
  history,
  accountNumberError,
  spinner,
  alertBoxError,
  accountNumberTransform,
  content: { copy, analytics },
}) => {
  const [showModal, setShowModal] = useState(false);
  const modalClick = (appName: string) => () => {
    interaction('click', {
      componentType: 'modal',
      id: 'accountNumCheck',
      parentContainer: 'accountNumCheck',
      appName,
      label: 'Find-your-account-number',
      state: 'opened',
    });
    setShowModal(true);
  };

  return (
    <Page>
      <AuthCard>
        <form>
          <Heading text={copy.headingText} />
          <InfoText text={copy.infoText} />
          {alertBoxError && (
            <Box marginBottom={8}>
              <AlertBox type="error" message={alertBoxError} markdown={true} />
            </Box>
          )}
          <TextField
            label="Electricity or natural gas account"
            name="account"
            disableIcon={!accountNumberError}
            type="tel"
            touched={true}
            transform={accountNumberTransform}
            onChange={onAccountNumberChange}
            onBlur={onAccountNumberBlur}
            error={accountNumberError}
          />
          <Box display="flex" marginTop={1} marginBottom={6}>
            <Text>
              <LinkChevron
                href="#"
                text="Where to find your account number"
                onClick={modalClick(analytics.interaction.click.appName)}
              />
            </Text>
          </Box>
          <Button
            text="Let's check"
            type="submit"
            data-id="look-for-email"
            name="lookForMyEmail"
            block={true}
            onClick={onSubmit}
            spinner={spinner}
          />
          <BackButton history={history} />
          {showModal && <AccountNumberInfoModalView onDismiss={() => setShowModal(false)} />}
        </form>
      </AuthCard>
    </Page>
  );
};

export { AccountNumberView };
